import React, { useMemo } from 'react';

const FLAKE_COUNT = 28;

export default function SnowParticles() {
  const flakes = useMemo(
    () =>
      Array.from({ length: FLAKE_COUNT }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        size: Math.random() * 2.5 + 0.8,
        delay: -(Math.random() * 18),
        duration: Math.random() * 10 + 10,
        opacity: Math.random() * 0.28 + 0.08,
        drift: (Math.random() - 0.5) * 30,
      })),
    []
  );

  return (
    <div className="snow-container" aria-hidden="true">
      {flakes.map((f) => (
        <div
          key={f.id}
          className="snowflake"
          style={{
            left: `${f.left}%`,
            width: `${f.size}px`,
            height: `${f.size}px`,
            opacity: f.opacity,
            animationDuration: `${f.duration}s`,
            animationDelay: `${f.delay}s`,
            '--drift': `${f.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
